import React, { FC } from "react";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { DEFAULT_FADE_DURATION } from "@app/constants";

export const PressContact: FC = () => {
  const { t } = useTranslation("p_contact");

  return (
    <section
      className={classNames(
        "px-5",
        "md:w-3/4",
        "lg:mx-auto lg:w-[71%] lg:px-0 lg:text-center",
        "xl:w-1/2 xl:max-w-[756px]",
      )}
    >
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <h4
          className={classNames(
            "mb-5 text-medium-large text-primary-content",
            "lg:text-huge",
          )}
        >
          {t("press_title")}
        </h4>
        <p
          className={classNames(
            "text-regular text-base-400",
            "xl:text-medium-large",
          )}
        >
          <Trans
            t={t}
            i18nKey="press_body"
            components={[
              <a
                key="mailto"
                href="mailto:alpian@farner.ch"
                target="_blank"
                rel="noopener noreferrer"
              />,
            ]}
          />
        </p>
      </Fade>
    </section>
  );
};
